import { axiosGraphApi, axiosServiceNowApi } from 'services/Api'
import { Dispatch } from 'redux'
import { AxiosResponse, AxiosError } from 'axios'
import { AuthenticationAction, DataUsersDataContext, DataUserDataContext, UserDataContextTypeInitiator } from 'types/autentication'
import { REDUX } from 'constants/'
import { ROUTES_NAMES } from 'constants/servicenow.routes'
import store from 'store'

const AuthenticationActions = {
    getAuthenticatedUser: async (dispatch: Dispatch<AuthenticationAction>) => {
        try {
            const res = await axiosGraphApi.get('/me')
            dispatch({
                type: REDUX.reducers.GET_AUTHENTICATED_USER,
                payload: res.data.value
            } as AuthenticationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.ERROR_AUTHENTICATION,
                payload: error
            } as AuthenticationAction)
        }

        return '/me'
    },
    getUserBySaAccountName: async (dispatch: Dispatch<AuthenticationAction>, saAccountName: string, accessToken: string) => {
        const url = ROUTES_NAMES.user.get.by_saaccount_name(saAccountName)

        try {
            const res = await axiosServiceNowApi?.get(url)
            let value = []
            if (JSON.stringify(res.data) === '[]') {
                let user = UserDataContextTypeInitiator
                user.displayName = 'Não encontrado'
                user.mail = `${saAccountName}@rededor.com.br`
                user.userPrincipalName = `${saAccountName}@rededor.com.br`
                value.push(user)
            } else {
                value = res.data
            }
            dispatch({
                type: REDUX.reducers.GET_USER_BY_ACCOUNT_NAME,
                payload: value
            } as AuthenticationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.ERROR_AUTHENTICATION,
                payload: error
            } as AuthenticationAction)
        }

        return url
    },
    setDataJwt: (dispatch: Dispatch<AuthenticationAction>, tokenData: any) => {
        let dataJwt = store?.getState()?.authenticationReducers?.dataJwt
        if(JSON.stringify(dataJwt) != JSON.stringify(tokenData)){
            dispatch({
                type: REDUX.reducers.SET_USER_TOKEN,
                payload: tokenData
            } as AuthenticationAction)
        }
        return tokenData
    },
    setDataAzure: async (dispatch: Dispatch<AuthenticationAction>, tokenData: any) => {
        dispatch({
            type: REDUX.reducers.SET_AZURE_TOKEN,
            payload: tokenData
        } as AuthenticationAction)

        return tokenData
    },
    showHeader: async (dispatch: Dispatch<AuthenticationAction>, choose: boolean) => {
        dispatch({
            type: REDUX.reducers.SET_SHOW_HEADER,
            payload: choose
        } as AuthenticationAction)
        return choose
    },
    setTokenJwtExpired: async (dispatch: Dispatch<AuthenticationAction>, choose: boolean, message: any) => {
        dispatch({
            type: REDUX.reducers.SET_JWT_TOKEN_ACCESS_TOKEN_EXPIRED,
            payload: choose
        } as AuthenticationAction)
        dispatch({
            type: REDUX.reducers.ERROR_AUTHENTICATION,
            payload: message
        } as AuthenticationAction)
        return choose
    },
}


export default AuthenticationActions